import { CentraLocaleShippingCountryCode } from "@/data/centra-locale-shipping-country-code"
import { klaviyoConfig } from "@/lib/klaviyo-client/klaviyo-config"

// Fetch the Klaviyo list ID for the given country code
export const getKlaviyoListId = (countryCode: CentraLocaleShippingCountryCode) => {
    // const isProduction = process.env.VERCEL_GIT_COMMIT_REF === "main" || process.env.VERCEL_GIT_COMMIT_REF === "main-cms-preview";
    const isProduction = process.env.NEXT_PUBLIC_KLAVIYO_ID === "R8UBuv"

    const listIds = isProduction
        ? klaviyoConfig.newsletterList.production
        : klaviyoConfig.newsletterList.qa

    if (countryCode in listIds) {
        return listIds[countryCode as keyof typeof listIds]
    } else {
        return listIds.default
    }
}
